import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class ReportAuditService extends BaseService {
  protected constructor(protected httpService: HttpService) {
    super('ReportAudit', httpService);
  }

  updateReportAuditDetails(type: string, key: string, status: string): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/UpdateReportAuditDetails`, { type, key, status });
  }
}
